import { render, staticRenderFns } from "./Cohorts.vue?vue&type=template&id=6b979836&"
import script from "./Cohorts.vue?vue&type=script&lang=js&"
export * from "./Cohorts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports